import { buttonStyle, fieldStyle, labelStyle } from './changeOrderStyles';

export default function UploadChangeOrderForm({
  file,
  fileUrl,
  title,
  changeNumber,
  initialPages,
  uploading,
  loading,
  customer,
  address,
  jobId,
  onSubmit,
  onFileChange,
  onTitleChange,
  onChangeNumberChange,
  onInitialPagesChange,
}) {
  return (
    <form
      onSubmit={onSubmit}
      style={{ marginTop: 18, padding: 16, background: '#f2f6fb', borderRadius: 9 }}
    >
      <h4 style={{ margin: '0 0 12px', color: '#26364d', fontSize: 14 }}>
        Create draft from a PDF
      </h4>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))',
          gap: 10,
        }}
      >
        <label style={labelStyle}>
          Change order title
          <input
            required
            maxLength={160}
            value={title}
            onChange={(event) => onTitleChange(event.target.value)}
            style={fieldStyle}
          />
        </label>
        <label style={labelStyle}>
          Change number
          <input
            required
            maxLength={50}
            value={changeNumber}
            onChange={(event) => onChangeNumberChange(event.target.value)}
            style={fieldStyle}
          />
        </label>
      </div>
      <label style={{ ...labelStyle, marginTop: 10 }}>
        Complete PDF (maximum 10 MB)
        <input
          required
          type="file"
          accept="application/pdf,.pdf"
          onChange={(event) => onFileChange(event.target.files?.[0] || null)}
          style={{ ...fieldStyle, padding: 8 }}
        />
      </label>
      <label style={{ ...labelStyle, marginTop: 10 }}>
        Pages requiring customer initials
        <input
          value={initialPages}
          onChange={(event) => onInitialPagesChange(event.target.value)}
          placeholder="Optional, e.g. 2, 4"
          style={fieldStyle}
        />
      </label>
      <p style={{ fontSize: 12, color: '#68778b', lineHeight: 1.5, margin: '8px 0 12px' }}>
        Include the full change order and every attachment in this single PDF. Uploading creates a
        draft only; it is never sent automatically. Uploaded the wrong PDF? Void its unsent
        draft first, then upload the correct PDF using the same change number. The voided
        copy stays in the history.
      </p>

      {file && (
        <div
          style={{
            border: '1px solid #ccd8e6',
            borderRadius: 8,
            background: '#fff',
            overflow: 'hidden',
            marginBottom: 12,
          }}
        >
          <div style={{ padding: '11px 13px', fontSize: 12, lineHeight: 1.6, color: '#33445d' }}>
            <strong>Verify the account and document before upload</strong>
            <br />
            Customer: {customer}
            <br />
            Property: {address}
            <br />
            Job reference: {jobId ?? '—'} · File: {file.name}
          </div>
          {fileUrl && (
            <iframe
              title="Selected change order PDF preview"
              src={fileUrl}
              style={{
                width: '100%',
                height: 340,
                border: 0,
                borderTop: '1px solid #dbe3ef',
              }}
            />
          )}
        </div>
      )}
      <button type="submit" disabled={uploading || loading} style={buttonStyle('primary')}>
        {uploading ? 'Saving draft…' : 'Upload as draft'}
      </button>
    </form>
  );
}
